import { Modal, Spin } from "antd";
import { ModalProps } from "antd/lib/modal";
import React from "react";
import "moment/locale/zh-cn";
import style from "./index.module.scss";
import {
    CurrentUserType,
    getUserName,
    getUserNo,
    openSession,
    OppositeUserType,
    SessionType,
    useRequest
} from "../../polyfills";
import { v4 as uuid } from "uuid";
import WebIMProvider from "../WebIMProvider";
import MessageList from "../MessageList";
import SendMsg from "../SendMsg";

interface ChatModalProps extends ModalProps {
    courseNo: string;
    courseSeq: string;
    selectedContact: { no: string; name: string };
}

export default function ChatModal({
    courseNo,
    courseSeq,
    selectedContact,
    ...resProps
}: ChatModalProps) {
    const [sessionId, { loading }] = useRequest(
        async () => {
            if (!resProps.visible) return;
            if (!courseNo || !courseSeq || !selectedContact) return;

            const params = {
                guid: uuid(),
                chatConferees: [
                    {
                        no: getUserNo(),
                        name: getUserName(),
                        type: CurrentUserType
                    },
                    {
                        no: selectedContact.no,
                        name: selectedContact.name,
                        type: OppositeUserType
                    }
                ],
                sessionType: SessionType.One
            };

            const data = await openSession(params);
            return data.guid;
        },
        {},
        [courseNo, courseSeq, selectedContact, resProps.visible]
    );

    return (
        <Modal
            width={800}
            title={selectedContact.name}
            maskClosable={false}
            className={style.root}
            footer={null}
            {...resProps}>
            <Spin spinning={loading}>
                <div className={style.body}>
                    {sessionId && (
                        <WebIMProvider initSession={sessionId}>
                            <MessageList sessionId={sessionId} />
                            <SendMsg
                                sessionId={sessionId}
                                courseNo={courseNo}
                                courseSeq={courseSeq}
                            />
                        </WebIMProvider>
                    )}
                </div>
            </Spin>
        </Modal>
    );
}
